import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeSharedModule } from '../../../../shared/font-awesome/font-awesome';
import { DELETE_ORGANIZATION_MODAL_ID } from '../../constants/organization-constants';
import { DialogService } from '../../../../shared/services/dialog.service';

@Component({
  selector: 'app-delete-organization-confirmation-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeSharedModule],
  templateUrl: './delete-organization-confirmation-modal.component.html',
})
export class DeleteOrganizationConfirmationModalComponent {
  private dialogService = inject(DialogService);
  modalId = DELETE_ORGANIZATION_MODAL_ID;
  @Input() organizationName: string = '';

  @Output() confirmed = new EventEmitter<void>();

  closeModal() {
    this.dialogService.close(DELETE_ORGANIZATION_MODAL_ID);
  }

  onBackdropClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.id === this.modalId) {
      this.closeModal();
    }
  }

  onConfirm() {
    this.confirmed.emit();
    this.closeModal();
  }
}

